import React, {useCallback, useContext, useEffect, useReducer, useState} from 'react';
import clsx from "clsx";
import {
	Card,
	CardActions,
	CardContent,
	CardHeader,
	LinearProgress,
	Tooltip,
	Typography
} from "@mui/material";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import Button from "@mui/material/Button";
import {useForm, FormProvider} from "react-hook-form";
import {CSV_INITIAL_STATE, CsvReducer, initCsvState} from "../../../../reducers/CsvReducer";
import {setOpenSnackbar} from "../../../../services/AppServices";
import {AppContext} from "../../../../App";
import FileInput from "../utils/FileInput";
import {addTamponi, checkStatusUpload} from "../../../../services/CsvServices";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import gp from "../../../../assets/gestione_pazienti.png";
import {blue} from "@mui/material/colors";

function LinearProgressWithLabel(props) {
	return (
		<Box display="flex" alignItems="center">
			<Box width="100%" mr={1}>
				<LinearProgress variant="determinate" {...props} />
			</Box>
			<Box minWidth={35}>
				<Typography variant="body2" color="textSecondary">{`${Math.round(
					props.value,
				)}%`}</Typography>
			</Box>
		</Box>
	);
}

LinearProgressWithLabel.propTypes = {
	/**
	 * The value of the progress indicator for the determinate and buffer variants.
	 * Value between 0 and 100.
	 */
	value: PropTypes.number.isRequired,
};

const TamponiCard = () => {
	const classes = BaseStyle();
	const methods = useForm({mode: "onChange",});
	const [state, dispatch] = useReducer(CsvReducer, CSV_INITIAL_STATE, initCsvState);
	const appContext = useContext(AppContext);
	const [submit, setSubmit] = useState(false);
	const [startCheck, setStartCheck] = useState(false);
	
	const onSubmit = useCallback((data) => {
		setSubmit(true)
		addTamponi(data, dispatch)
	}, [dispatch])
	
	useEffect(() => {
		if (submit && !state.loadingAddTamponi && state.errorAddTamponi === "") {
			setOpenSnackbar("success", "Caricamento in corso", appContext.dispatch);
			setSubmit(false);
			setStartCheck(true);
			checkStatusUpload(state.idUpload, dispatch);
		}
	}, [state.loadingAddTamponi, state.errorAddTamponi, appContext.dispatch, submit, state.idUpload]);
	
	useEffect(() => {
		if (startCheck && !state.loadingCheckStatus && state.errorCheckStatus === "") {
			if (state.status?.percentage < 100) {
				setTimeout(() => {
					checkStatusUpload(state.idUpload, dispatch);
				}, 2000)
			} else {
				setStartCheck(false);
			}
		} else if (startCheck && !state.loadingCheckStatus && state.errorCheckStatus !== "") {
			setStartCheck(false);
			alert(state.errorCheckStatus);
		}
	}, [startCheck, state.loadingCheckStatus, state.errorCheckStatus, state.status, state.idUpload])
	
	return (
		<React.Fragment>
			<Card className={clsx(classes.roundBorder, classes.transparent)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<FormProvider {...methods} >
					<form onSubmit={methods.handleSubmit(onSubmit)}>
						<CardHeader
							title={<Typography variant={"h6"}><b>Caricamento dei tamponi</b></Typography>}
							subheader={"Segui le indicazioni per caricare correttamente i tamponi da Gestione Pazienti. In caso di errori durante il " +
								"caricamento ti invito a contattare tempestivamente gli sviluppatori dlell'ICT"}
						/>
						<CardContent style={{flexGrow: 1}}>
							
							{/*<Typography component={"div"} style={{marginBottom: 20}}>*/}
							{/*	<b>Indicazioni per caricare il file</b><br/>*/}
							{/*	<ul style={{listStyleType: "none"}}>*/}
							{/*		<li style={{*/}
							{/*			padding: 20,*/}
							{/*			backgroundColor: blue[50],*/}
							{/*			color: blue[900],*/}
							{/*			borderRadius: 22,*/}
							{/*			marginBottom: 12*/}
							{/*		}}><span style={{fontSize: 24}}>1)</span> Vai su*/}
							{/*			Gestione Pazienti: <i>url: <a*/}
							{/*				href={"https://webcovid.sdp.csi.it/gestionepazienti/#/richiesta-tamponi"} rel={"noreferrer"}*/}
							{/*				target={"_blank"}>https://webcovid.sdp.csi.it/gestionepazienti/#/richiesta-tamponi</a></i><br/>*/}
							{/*		</li>*/}
							{/*		<li style={{*/}
							{/*			padding: 20,*/}
							{/*			backgroundColor: blue[50],*/}
							{/*			color: blue[900],*/}
							{/*			borderRadius: 22,*/}
							{/*			marginBottom: 12*/}
							{/*		}}><span style={{fontSize: 24}}>2)</span> Inserisci le seguenti credenziali:<br/>*/}
							{/*			Username: <i>rob******@IPA</i><br/>*/}
							{/*			Password: <i>Pi****_03</i><br/>*/}
							{/*			PIN: <i>7DM22LWB</i><br/>*/}
							{/*		</li>*/}
							{/*		<li style={{*/}
							{/*			padding: 20,*/}
							{/*			backgroundColor: blue[50],*/}
							{/*			color: blue[900],*/}
							{/*			borderRadius: 22,*/}
							{/*			marginBottom: 12*/}
							{/*		}}><span style={{fontSize: 24}}>3)</span> Una volta effettuato l'accesso clicca su "Tamponi" (nel menù*/}
							{/*			a sinistra) e successivamente su*/}
							{/*			"Richieste Tamponi".*/}
							{/*			<br/>*/}
							{/*			<br/>*/}
							{/*			Ti si aprirà questa schermata:<br/>*/}
							{/*			<img alt={"Gestione pazienti"} src={gp} width={1600}/>*/}
							{/*		</li>*/}
							{/*		<li style={{*/}
							{/*			padding: 20,*/}
							{/*			backgroundColor: blue[50],*/}
							{/*			color: blue[900],*/}
							{/*			borderRadius: 22,*/}
							{/*			marginBottom: 12*/}
							{/*		}}><span style={{fontSize: 24}}>4)</span> Ora inserisci i seguenti filtri:<br/>*/}
							{/*			<ul>*/}
							{/*				<li>Esito test: "POSITIVO"</li>*/}
							{/*				<li>Data prelievo prevista: "(la data di oggi o la data desiderata)"</li>*/}
							{/*			</ul>*/}
							{/*		</li>*/}
							{/*		<li style={{*/}
							{/*			padding: 20,*/}
							{/*			backgroundColor: blue[50],*/}
							{/*			color: blue[900],*/}
							{/*			borderRadius: 22,*/}
							{/*			marginBottom: 12*/}
							{/*		}}><span style={{fontSize: 24}}>5)</span> Effettua lo scarico (cliccando prima su "<b>cerca</b>" e poi*/}
							{/*			su*/}
							{/*			"<b>scarica excel</b>") per tutti i giorni da oggi fino a 5 / 6 giorni indietro<br/>*/}
							{/*			<b>NB: devi per obbligatoriamente cercare prima di scaricare il file, altrimenti non funziona il*/}
							{/*				bottone</b>*/}
							{/*		</li>*/}
							{/*		<li style={{*/}
							{/*			padding: 20,*/}
							{/*			backgroundColor: blue[50],*/}
							{/*			color: blue[900],*/}
							{/*			borderRadius: 22,*/}
							{/*			marginBottom: 12*/}
							{/*		}}><span style={{fontSize: 24}}>6)</span> Trascina il file nell'area tratteggiata che trovi qui sotto*/}
							{/*			👇<br/>*/}
							{/*			<b style={{*/}
							{/*				fontSize: 20, color: blue[600]*/}
							{/*			}}>NB: Non aprire il file in nessun modo, fidati di quello che hai scaricato!! Caricalo su Ocean*/}
							{/*				così com'è senza porre alcuna modifica o aprirlo!!</b>*/}
							{/*		</li>*/}
							{/*		<li style={{*/}
							{/*			padding: 20,*/}
							{/*			backgroundColor: blue[50],*/}
							{/*			color: blue[900],*/}
							{/*			borderRadius: 22,*/}
							{/*			marginBottom: 12*/}
							{/*		}}><span style={{fontSize: 24}}>7)</span> Una volta che visualizzi il file nel riquadro puoi cliccare*/}
							{/*			sul bottone blu "Conferma e carica" ed*/}
							{/*			attendi il completamento.<br/>*/}
							{/*			<b style={{*/}
							{/*				fontSize: 20, color: blue[600]*/}
							{/*			}}>NB: Puoi utilizzare sia la barra progresso che la tabella sottostante per verificare l'avvenuta*/}
							{/*				del caricamento effettuando un aggiornamento della tabella con l'apposito bottone "REFRESH*/}
							{/*				TABELLA"</b>*/}
							{/*		</li>*/}
							{/*		<li style={{*/}
							{/*			padding: 20,*/}
							{/*			backgroundColor: blue[50],*/}
							{/*			color: blue[900],*/}
							{/*			borderRadius: 22,*/}
							{/*			marginBottom: 12*/}
							{/*		}}><span style={{fontSize: 24}}>8)</span> <i>opzionale</i><br/>*/}
							{/*			<i>Una volta che il caricamento è stato effettuato è consigliato un refresh della pagina per evitare*/}
							{/*				possibili anomalie (file ancora presente nell'input, barra progresso fissa a 100, ...).</i>*/}
							{/*		</li>*/}
							{/*	</ul>*/}
							{/*</Typography>*/}
							
							<FileInput
								accept='.csv'
								multiple
								name='csv'
							/>
							
							<LinearProgressWithLabel value={state.status.percentage ? state.status.percentage : 0}/>
						
						</CardContent>
						<CardActions className={classes.flexRight}>
							<Tooltip
								title={"Dopo aver controllato minuziosamente di aver caricato il file in modo corretto e nel giusto formato, " +
									"clicca su conferma per inviarlo al server che farà le magie."}>
								<Button variant={"contained"} disableElevation size="small" color="primary"
								        style={{borderRadius: 24}}
								        className={classes.roundButton} onClick={methods.handleSubmit(onSubmit)}>
									<b>Conferma e carica</b>
								</Button>
							</Tooltip>
						</CardActions>
					</form>
				</FormProvider>
			</Card>
		</React.Fragment>
	);
}

export default React.memo(TamponiCard)

// MARIA GIGROUP
